module.exports = __webpack_public_path__ + "img/AMERICAS_Mexico_Tuxpan_Aerial_Tanks_2021-06_1920x550.992289b2.jpg";